var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PopupBox',{class:_vm.$style['popup'],on:{"miss":function($event){return _vm.$emit('miss')}}},[_c('ProfileMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }